module.exports = __webpack_public_path__ + "static/media/dove.e1c78628.svg";